export const defaultLocale = "fr";

export const supportedLocales = ["fr", "en"];

export const localeLabels = {
  fr: "FR",
  en: "EN",
};

export const localeNames = {
  fr: "Français",
  en: "English",
};

export function isSupportedLocale(locale) {
  return supportedLocales.includes(locale);
}

export function getLocaleFromPath(path) {
  const locale = path.split("/")[1];
  return isSupportedLocale(locale) ? locale : defaultLocale;
}

export function stripLocalePrefix(path) {
  const parts = path.split("/");
  const locale = parts[1];

  if (!isSupportedLocale(locale)) {
    return path || "/";
  }

  const routePath = `/${parts.slice(2).join("/")}`;
  return routePath === "/" ? "/" : routePath.replace(/\/$/, "");
}
